import { useCallback, useState } from 'react';
import { IModifications } from '../contexts/styles-context/types/modifications.type';
import { IStylesType } from '../contexts/styles-context/types/styles.type';

export const useCustomStylesOnHover = (customStyles: Record<string, any>) => {
  const [modifiedCustomStyles, setModifiedCustomStyles] = useState(customStyles as IStylesType);
  
  const onMouseEnter = useCallback((element: keyof Omit<IModifications, "common">) => {
    setModifiedCustomStyles(prevState => {
      return { ...prevState, [element]: { ...prevState[element], ...prevState[element + "OnHover"]} }
    });
  }, []);
  
  const onMouseOut = useCallback((element: keyof Omit<IModifications, "common">) => {
    setModifiedCustomStyles(prevState => {
      return { ...prevState, [element]: customStyles[element] }
    });
  }, [ customStyles ]);

  return { modifiedCustomStyles, onMouseEnter, onMouseOut }
}